import firebase from 'firebase';
import {VisitModel} from './visit.model';
import {User} from './user.model';
import {EatingHabitModel} from './eating-habit.model';
import {ProvinceModel} from './province.model';
import {CountyModel} from './county.model';
import {TokenGeneratorUtil} from '../util/token-generator.util';
import {TreatmentCase} from './treatment-case';
import {UnapModel} from './unap.model';
import GeoPoint = firebase.firestore.GeoPoint;

export class ChildCaseModel implements TreatmentCase {

    public objectID: string;
    public token: string;
    public muac: number;
    public marker: string;
    public anotherDisease: string;
    public chronicDisease: string;
    public childToken: string;
    public childName: string;
    public firstName: string;
    public lastName: string;
    public gender: string;
    public birthCertificateNumber: string;
    public mothersName: string;
    public mothersPhone: string;
    public caregiverName: string;
    public caregiverPhone: string;
    public childBirthDate: Date;
    public childBirthDateTimestamp: number;
    public childSelfie: string;
    public childSelfieRef: string;
    public childReferredToTheHospital: boolean;
    public assistantUid: string;
    public organizationName: string;
    public organizationInitials: string;
    public organization: UnapModel;
    public province: string;
    public provinceModel: ProvinceModel;
    public county: string;
    public countyModel: CountyModel;
    public date: Date;
    public dateTimestamp: number;
    public updateDate: Date;
    public nextVisit: string;
    public nextVisitDate: Date;
    public nextVisitTimestamp: number;
    public yearOfVisit: number;
    public visits = new Array<VisitModel>();
    public identifierAssistant: User;
    public transferAssistant: User;
    public transferredCase = false;
    public healthAssistants = new Array<User>();
    public currentAssistantUid: string;
    public healthAssistantsUids = new Array<string>();
    public symptoms: Array<string>;
    public comments: string;
    public alert: any;
    public icon: any;
    public iconAlert!: any;
    public eatingHabits = new Array<EatingHabitModel>();
    public identifiedCase = false;
    public location: GeoPoint;
    public childAddress: string;
    public appVersion: string;
    public updated = false;

    // New fields
    public weight: number | null = null; // In kg
    public height: number | null = null; // In cm
    public imc: number | null = null; // In cm
    public newProtocol: boolean = true; // NP
    public currentHealthAssistant!: User | undefined | null;
    public vaccines = new Array<string>();
    public vaccinesInVisit = new Array<string>();
    public dewormingPeriod: string = '';
    public attentionIcon: string = '';
    public hospitalCase: boolean = false;
    public currentDiagnosis!: string;
    public imcLevel: string = '';
    public imcRangeIndicator: string = '';
    public level: string = '';
    public rangeIndicator: string = '';
    public weightLevel: string = '';
    public weightRangeIndicator: string = '';
    public heightLevel: string = '';
    public heightRangeIndicator: string = '';
    public heightToWeightLevel: string = '';
    public heightToWeightIndicator: string = '';
    public lastUserUpdate: string | undefined | null;
    public vaccinationDate!: Date;
    public dewormingDate!: Date;
    public vaccinationUnity!: string | null;
    public classification: number = 30;
    public hospitalizationCauses: string[] = [];
    public outOfDateVisit: boolean = false;

    constructor(private assistant?: User) {
        this.newProtocol = true;
        this.healthAssistants.push(assistant);
        this.assistantUid = assistant.uid;
        this.healthAssistantsUids.push(assistant.uid);
        this.organizationInitials = assistant.organizationInitials;
        this.organizationName = assistant.organizationName;
        this.childToken = TokenGeneratorUtil.generateToken();
        this.token = TokenGeneratorUtil.generateToken();
    }

    public addEatingHabits(eatingHabits: EatingHabitModel) {
        if (eatingHabits) {
            let order: number = this.visits.filter(visit => visit.date).length || 0;
            eatingHabits.order = order++;
            this.eatingHabits.push(eatingHabits);
        }
    }

}
